const brandPurpleLighter = '#9275fa';
const brandPurpleLight = '#8362f9';
const brandPurple = '#523df1';
const brandPurpleDark = '#5e2cf5';
const brandPurpleDarker = '#4430dd';

const coal = '#2a2637';
const coalDark = '#1d192b';

const raisinLight = '#222031';
const raisin = '#191527';
const raisinDark = '#090719';

const eerieLight = '#242424';
const eerie = '#202121';
const eerieDark = '#1d1d1d';

const redLight = '#ff004c';
const red = '#ee0a4a';

export const designColor = {
    brandPurpleLighter,
    brandPurpleLight,
    brandPurple,
    brandPurpleDark,
    brandPurpleDarker,
    coal,
    coalDark,
    raisinLight,
    raisin,
    raisinDark,
    eerieLight,
    eerie,
    eerieDark,
    redLight,
    red,
};

// TODO: This color palette should be global and not scoped
// to `FloorGame`. This is here only until we have shipped
// `FloorGame` and have time to re-evaluate how we share colors.
export const floorGameColor = {
    white: '#fff',
    cementWet: '#3c3a34',
    ash: '#848484',
    onyx: '#404148',
    jet: '#323232',
    coal: eerieLight,
    eerie: eerieDark,
    // oil: '#141414',
    black: '#000',
    red,
    green: '#62fa71',
    forest: '#3abe57',
    forestDark: '#34ab4e',
    blackberry: '#25233e',
    blackberryDark: '#191C2e',
    grape: '#47108a',
    grapeDark: '#2d144d',
    blue: '#101c8a',
    gold: '#8a6810',
    yellow: '#ffd222',
    mustard: '#ffcb46',
};
